export const CONRACT_ADDRESS="0xe9615071341c6F0392A5dFDE1645Ad01b810cB43";
export const PAIR_ADDRESS="0xd8264b532a0a6c4a883eb4314c005c8ccad57f31"

export const telegram = "https://t.me/shibvinci_portal";
export const uniswap = "https://app.uniswap.org/#/swap?outputCurrency=" + CONRACT_ADDRESS;
export const whitepaper = "/pdf/whitepaper.pdf";
export const chart = "https://www.dextools.io/app/ether/pair-explorer/" + PAIR_ADDRESS;
export const twitter = "https://twitter.com/shib_vinci";
export const etherscan = "https://etherscan.io/address/" + CONRACT_ADDRESS;